import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

import { MainTitleComponent } from '@connect-services/client/components/main-title/main-title.component';
import { ActionsEnum } from '@connect-services/client/models/panel.model';
import { SelectComponent, SelectOption } from '@connect-services/src/lib/components/select/select.component';
import { Standard } from '@connect-services/src/sdk/api';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MainTitleComponent, RessourcesModule, SelectComponent],
    selector: 'app-select-statistics-panel',
    templateUrl: './select-statistics-panel.component.html',
})
export class SelectStatisticsPanelComponent {
    public readonly data = input.required<SelectOption<Standard>[]>();
    public readonly icon = input.required<IconProp>();
    public readonly placeholder = input.required<string>();
    public selectionChange = output<Standard[]>();
    public readonly subtitle = input<string>();
    public readonly title = input.required<string>();

    protected readonly ActionsEnum = ActionsEnum;

    public onSelectionChange(values: Standard[]): void {
        this.selectionChange.emit(values);
    }
}
